import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to AquaDrop",
    title: "Water Delivered, Life Elevated",
    buttonText: "Our Products",
    buttonLink: "Shop-grid",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to AquaDrop",
    title: "Pure Water, Direct Delivery",
    buttonText: "Our Products",
    buttonLink: "Shop-grid",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to AquaDrop",
    title: "Stay hydrated, stay healthy",
    buttonText: "Our Products",
    buttonLink: "Shop-grid",
  },
];

export default home;